import React, { Component } from 'react';
import { observer } from "mobx-react";
import { makeObservable, observable, action } from 'mobx';
import 'Styles/commonComponents/Settings/SettingsSubBlock.scss';

class SettingsSubBlock extends Component {
    render() {
        return (
            <div
                id={this.props.id}
                className={`SettingsSubBlock ${this.props.className ?? ""}`}
            >
                <div className="SettingsSubBlock-container">
                    <div className="SettingsSubBlock-title">{this.props.title}</div>
                    <div className="SettingsSubBlock-settings-container">{this.props.children}</div>
                </div>
            </div>
        )
    }
};

export default observer(SettingsSubBlock);